import React from "react"
import { GatsbyImage } from "gatsby-plugin-image";
import { useStaticQuery, graphql , Link} from "gatsby"

const Gridreelsdetail = () => {
    const datareels = useStaticQuery(graphql`
    {
        allStrapiReels (
            sort: {order: DESC, fields: published_at}
        ){
            edges {
                node {
                    id
                    slug
                    titulo
                    tiemporeceta
                    published_at
                    poster {
                        localFile {
                            childImageSharp {
                                gatsbyImageData(layout: CONSTRAINED, placeholder: NONE)
                            }
                        }
                    }
                    meta
                    badge
                }
            }
        }
    }
    `)

      return (  
      <div className="bg-white">
          <div className="max-w-2xl mx-auto py-6 px-4 sm:py-4 sm:px-6 lg:max-w-6xl lg:px-8 mb-8">
          <div className="grid grid-cols-1">
              <ul role="list" className="sm:grid sm:grid-cols-4 list-none gap-4">
                  {datareels.allStrapiReels.edges.map((reels) => (
                  <li key={reels.node.id}>
                    <Link to={`/reels/${reels.node.slug}`}>
                      <div className="items-center relative bg-gradient-to-t from-negrotransparente">
                      <GatsbyImage
                          alt={`${reels.node.titulo}`}
                          image={
                            reels.node.poster.localFile.childImageSharp
                          .gatsbyImageData
                          }
                          className="w-full h-full aspect-w-9 aspect-h-16"       
                      />
                      {reels.node.badge &&
                        <div className="absolute top-0 text-sm px-3 bg-white text-black rounded">{reels.node.badge}</div>
                      }
                      <div className="absolute left-1/2 transform -translate-x-1/2 justify-end  top-1/2 -translate-y-1/2">
                            <img src="https://recetascocinasana.s3.eu-west-1.amazonaws.com/iconoplay_a40a72c71a.png" alt="play" className="w-20" />
                      </div>
                      </div>
                      <div className="text-center">
                        <div className="">
                            <p className="uppercase leading-5 text-s18 text-verde mt-6 pb-2 text-center font-bold">{reels.node.meta}</p>
                            <h3 className="text-s24 leading-7 px-6 md:px-6 archersemibold text-center text-black w500 pb-8 md:pb-0">{reels.node.titulo}</h3>
                        </div>
                      </div>
                      
                    </Link>
                  </li>
                  ))}
              </ul>
          </div>
          </div>
      </div>
  )
        
}     

    export default Gridreelsdetail;